<div class="form-group">
    <span class="label">{{title}}</span>

    <input-slider 
    [id]="id" 
    [title]="title" 
    [control]="control" 
    [titleValuesPlural]="titleValuesPlural" 
    [titleValuesSingular]="titleValuesSingular" 
    [range]="range"
    [format]="format" 
    [secondaryMaxText]="secondaryMaxText"
    (changeValuesEvent)="onChangeValuesSlider()"
    ></input-slider>

</div>
